import LazyComponent from "../../controls/LazyComponent";
function init(context) {
    context.registerSettings("Vortex", LazyComponent(() => require("./SettingsVortex")), undefined, undefined, 50);
    return true;
}
export default init;
